import MediaQuery from 'react-responsive'

export default MediaQuery
